import Vue from "vue";
import Vuex from "vuex";

import translations from "./store-translations.js";

Vue.use(Vuex);

export default function() {
  return new Vuex.Store({
    modules: {
      translations
    }
  });
}
